// extracted by mini-css-extract-plugin
module.exports = {"FooterBrand":"styles_FooterBrand__8oSzy","logo":"styles_logo__2acz1"};